/* Layout */
import Layout from '../../views/layout/Layout.vue'

const PostList = () => import(/* webpackChunkName: "post-list" */ '@/views/post/list')

export default [
  {
    path: '/post',
    component: Layout,
    redirect: '/post/list',
    name: 'Post',
    alwaysShow: true,
    meta: {
      title: 'post',
      icon: 'portrait',
    },
    children: [
      {
        path: 'list',
        component: PostList,
        name: 'PostList',
        meta: {
          title: 'list',
          icon: 'list',
          accessibleName: 'post',
        },
      },
    ],
  },
]
